const PERFILES = [
  {
    match: /innprofin/i,
    nombre: 'INNPROFIN',
    etiqueta: 'Seguros y protección financiera',
    descripcion: 'Encuentra asesoría personalizada y soluciones en seguros, protección y planificación financiera, con opciones para vida, accidentes, educación, viajes, ahorro e inversión.',
    telefono: '3229280050',
    web: 'https://www.instagram.com/innprofin_insurance?stkn=eGhrcDlsaW0yOG1t',
  },
  {
    match: /zona\s*fit/i,
    nombre: 'ZONA FIT',
    etiqueta: 'Bienestar',
    descripcion: 'Encuentra alternativas para cuidar tu bienestar y mantener un estilo de vida activo, con rutinas funcionales adaptadas a tus necesidades y opciones de alimentación saludable.',
    telefono: '3229280050',
    web: 'https://www.instagram.com/zonafit_quierete?stkn=MThmdXV1MjdqNGpvdQ==',
  },
  {
    match: /\bahm\b/i,
    nombre: 'AHM',
    etiqueta: 'Bienestar',
    descripcion: 'Haz parte de una comunidad que te acompaña en la construcción de hábitos sostenibles a través de nutrición, ejercicio y bienestar emocional, además de oportunidades de emprendimiento.',
    telefono: '3229280050',
    web: 'https://www.instagram.com/ahm_saludables?stkn=ZmV4b3ZkMjE3dWF0',
  },
  {
    match: /training|quality|tyq/i,
    nombre: 'TRAINING & QUALITY',
    etiqueta: 'Gestión, talento humano y SST',
    descripcion: 'Fortalece la gestión de tu organización mediante asesoría y capacitación en procesos, talento humano, cumplimiento legal y seguridad y salud en el trabajo.',
    web: 'https://www.instagram.com/tyq.strategies?stkn=OXJkdjJ6NWNuNTV1',
    pagoPendiente: true,
  },
  {
    match: /revive/i,
    nombre: 'REVIVE',
    etiqueta: 'Capacitación para el sector salud',
    descripcion: 'Conoce una plataforma de soluciones integrales para fortalecer la formación y el desarrollo de profesionales y organizaciones del sector salud, mediante educación, acompañamiento y tecnología.',
    pagoPendiente: true,
    cursosPendientes: true,
  },
];

export const enriquecerAliado = (aliado) => {
  const perfil = PERFILES.find((item) => item.match.test(aliado?.nombre || ''));
  if (!perfil) return aliado;
  return {
    ...aliado,
    nombre: perfil.nombre || aliado.nombre,
    etiqueta: perfil.etiqueta,
    descripcion: perfil.descripcion,
    telefono: perfil.telefono || null,
    web: perfil.web || null,
    pagoPendiente: Boolean(perfil.pagoPendiente),
    cursosPendientes: Boolean(perfil.cursosPendientes),
  };
};

export const dedupeAliados = (lista) => {
  const vistos = new Set();
  return (lista || []).filter((aliado) => {
    const clave = (aliado?.nombre || '').trim().toLowerCase();
    if (!clave || vistos.has(clave)) return false;
    vistos.add(clave);
    return true;
  });
};
